/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
    <el-button class="buttonimg">
      <img v-if="active == 1" class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <div class="post flexc-cen-x" v-if="showShou == true">
        <div  class="css cursor flex-xy" @click="toActive(1)"><div v-if="active == 1" class="heng1" >后台管理</div><div v-if="active == 0" class="wu " >后台管理</div></div>
        <div  class="css cursor flex-xy" @click="toActive(0)"><div v-if="active == 0" class="heng1">前台收银</div> <div v-if="active == 1" class="wu" >前台收银</div></div>
    </div>
        <el-submenu  class="submenu">
      <!-- <template slot="title">{{user.userRealName}}</template> -->
      <template slot="title">{{user}}</template>
      <el-menu-item index="2-1" @click="toxiu()">修改密码</el-menu-item>
      <!-- <template slot="title">修改米娜</template> -->
      <!-- <el-menu-item index="2-1">设置</el-menu-item>
      <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item> -->
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>
     <!-- <el-menu-item  class="submenu">
       <el-badge :value="200" :max="99" >
          <i class="el-icon-message-solid" style="color:white"></i>
      </el-badge>
     </el-menu-item> -->
    <el-dialog title="修改密码" :visible.sync="show" width="40%" >
      <el-form label-width="120px" >
        <el-form-item label="旧密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="input" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="Pwd">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="Pwd1">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd1" show-password auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary"  @click="topass()">修改</el-button>
      </div>
    </el-dialog>
     <!-- <transition name="el-zoom-in-bottom">
        <div class="message " v-show="showMessage">
          <div class="flex-spc-x">
            <div style="margin-top:10px;font-size:15px;margin-left:15px;color:#808080">温馨提示</div>
            <i class="el-icon-close" style="margin-right:5px;font-size:20px;color:black;"></i>
          </div>
          <div class="flex-xy w100" style="margin-top:25px">
              <div class="flexc-cen-x">
                <i class="el-icon-message" style="color:red;font-size:20px"></i>
                  <div style="color:black;margin-left:5px;font-size:13px">您有<span style="color:red">10</span>条预约消息待查收</div>
              </div> 
              <el-button type="text" style="margin-top:5px">查看详情</el-button>
          </div>
        
        </div>
     </transition> -->
  </el-menu>
</template>
<script>
import { loginout } from '../api/userMG'
import {editLoginPwd} from "@/api/getData";
import { baseUrl } from "../config/env.js";
import { ajax } from "../config/fetch.js";
export default {
  name: 'navcon',
  data() {
    return {
      Pwd1:'',
      IsActivity:'',
      Limits:'',
      active:1,
      collapsed: true,
      show:false,
      isCashier:'',
      Pwd:'',
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user:'',
      input:'',
        audio:'',
      showShou:false,    
      showMessage:false
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // this.audio = new Audio();
    // this.audio.src = "https://tp.xingxingzhihuo.com.cn/zhyk/Storesbg/shou.mp3";
    // let playPromise = ''
    // playPromise = this.audio.play();

    this.timing = setInterval(() => {
	       this.showMessage =true
	    }, 2000);
    if(localStorage.getItem('isAdmin') == 1 && localStorage.getItem('isCashier') == 1){
        this.showShou = true
    }
  this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 141 && localStorage.getItem('isCashier') == 1){
            this.showShou = true
          }
   })
    if(this.$router.app._route.name == "前台收银"){
        // this.showclass = 'aside'
           this.collapsed = false
           this.active  = 0
           this.$root.Bus.$emit('act', 0)
    }
    this.user = localStorage.getItem('Name')
    this.IsActivity = localStorage.getItem('IsActivity')
  },
  methods: {
    toActive(e){
      console.log(e)
        this.active = e
        if(this.active == 1){
           this.collapsed = true
        } else {
          this.collapsed = false
        }
         this.$root.Bus.$emit('act', e)
    },
    closeDialog(){
      this.show = false
    },
topass(){
   if(this.Pwd == '' && this.input == '' ){
      this.$message({
                  type: "error",
                  duration:2000,
                  message:'请输入新密码'
                });
        } else if(this.Pwd != this.Pwd1 ) {
                this.$message({
                  type: "error",
                  duration:2000,
                  message:'两次密码不一致'
                });
        } else {


 var tokenurl = baseUrl + "/ChangePassword.aspx";
      var _parm = {
  
        SelectStoresID:localStorage.getItem("StoresID"),
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        loginID:localStorage.getItem("LoginID"),
        Pwd:this.input,
        newPwd:this.Pwd
        //  UserID:this.ruleForm.LoginName,
        //   StoresID:this.ruleForm.Pwd,
    
      };
      var that = this;
      ajax({
        url: tokenurl,
        type: "POST",
        contentType: "application/json;",
        data: JSON.stringify(_parm),
        success: function (res) {
          let _res = JSON.parse(res);
          if (_res.orsuccess == "1") {
            that.show = false 
            that.$message({
              type: "success",
              message: "修改成功请重新登录",
            });
            
                that.$store.commit('login','false')
                that.$store.commit('logout','false')
                that.$router.push({ path: '/login'})
          } else{

            that.$message({
                duration:2000,
                message:_res.Msg
              });
          }
        },
      });




        }
        
    


    },

    toxiu(){
      this.Pwd = ''
      this.input = ''
      this.Pwd1 = ''
      this.show = true
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
         
        })
    },
    // 切换显示
    toggle(showtype) {
      console.log(showtype)
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>

<style>
.el-badge__content.is-fixed{
  margin-top:10px !important;
}
</style>
<style scoped>
.message{
  position: fixed;
  border-radius: 5px;
  right:0;
  bottom: 0;
  height: 120px;
  width:280px;
  margin-bottom: 10px;
  box-shadow: 0 0 5px #a0a0a0;
  background-color: rgb(255, 255, 255) !important;
  z-index: 99999;


}

.message:focus{
	outline:none;
}
.icon{
  position: absolute;
  z-index: 9999;
  right: 0;
  margin-top:20px;
  margin-right: 50px;
}
.post:focus{
	outline:none;
}

.post{
  position: absolute;
  margin-top: -45px;
  margin-left: 70px;
  z-index: 99;
  color: white;

}
.css{
  background-color: rgb(65, 88, 124);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  height: 45px;
  width: 100px;
  margin-left: 10px;
  font-size: 17px;
  font-weight: 700;
  /* box-shadow: -1px 0px 2px rgb(65, 88, 124); */
  
}
.wu{
  padding-bottom: 4px;
  /* border-bottom: 2px solid white; */
}
.heng1{
  padding-bottom: 2px;
  border-bottom: 2px solid white;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue